module.exports = {
	"dk": {
		"facebook": [
			{
				"title": "TV3SPORT",
				"name": "TV3SPORT"
			},
			{
				"title": "TV3 Sport Champions League",
				"name": "tv3sportcl"
			},
			{
				"title": "TV3 Sport NFL",
				"name": "tv3sportnfl"
			},
			{
				"title": "TV3 Sport Formel 1",
				"name": "meremotor"
			},
			{
				"title": "TV3 Sport Premier League",
				"name": "tv3sportpl"
			},
			{
				"title": "TV3 Sport Superliga",
				"name": "tv3sportsl"
			},
			{
				"title": "TV3 Sport La Liga",
				"name": "tv3sportlaliga"
			},
			{
				"title": "TV3 Sport Premier League",
				"name": "tv3sportpl"
			},
			{
				"title": "TV3 Sport Håndbold",
				"name": "tv3sporthaandbold"
			},
			{
				"title": "TV3 Sport Badminton",
				"name": "tv3sportbadminton"
			},
			{
				"title": "TV3 Sport Tennis",
				"name": "tv3sporttennis"
			},
			{
				"title": "FC Græsrødderne",
				"name": "fcgraes"
			},
			{
				"title": "Viaplay Fighting",
				"name": "viaplayfighting.dk"
			},
			{
				"title": "Viasat Golf Danmark",
				"name": "viasatgolfdk"
			}
		],
		"twitter": [
			{
				"title": "TV3sport",
				"url": "https://twitter.com/tv3sportdk",
				"logo": "tv3sportdk.jpeg"
			},
			{
				"title": "TV3 Sport PL",
				"url": "https://twitter.com/tv3sportpl",
				"logo": "tv3sportdk.jpeg"
			},
			{
				"title": "TV3 Sport SL",
				"url": "https://twitter.com/tv3sportsl",
				"logo": "tv3sportdk.jpeg"
			},
			{
				"title": "TV3 Sport CL",
				"url": "https://twitter.com/tv3sportcl",
				"logo": "tv3sportdk.jpeg"
			},
			{
				"title": "TV3 Sport Transfer",
				"url": "https://twitter.com/tv3transfer",
				"logo": "tv3sportdk.jpeg"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/socialMedia.json
// module id = 1209
// module chunks = 0 1